// src/pages/batch/components/MoleculeGrid.jsx
import React from "react";
import { Row, Checkbox, Spin } from "antd";
import HistoryGridItem from "./HistoryGridItem";

export const MoleculeGrid = ({
  loading,
  pagedData,
  images,
  selectedMap,
  onItemCheckChange,
  onSelectAllChange,
  allItemsSelected,
  someItemsSelected,
  filteredDataLength,
  handleCopyToClipboard,
}) => {
  return (
    <Spin spinning={loading}>
      <div style={{ marginBottom: 16 }}>
        <Checkbox
          indeterminate={someItemsSelected}
          checked={allItemsSelected}
          onChange={onSelectAllChange}
        >
          Select All ({Object.keys(selectedMap).length} / {filteredDataLength})
        </Checkbox>
      </div>
      <Row gutter={[12, 12]}>
        {pagedData.map((row) => (
          <HistoryGridItem
            key={row.molecule_id}
            item={row}
            image={images[row.molecule_id]}
            isLoading={!images[row.molecule_id]}
            onCopy={handleCopyToClipboard}
            formatReward={(r) => (r != null ? (+r).toFixed(3) : "N/A")}
            checked={!!selectedMap[row.molecule_id]}
            onCheckChange={(e) => onItemCheckChange(e.target.checked, row)}
          />
        ))}
      </Row>
    </Spin>
  );
};